export const convertDataToSelectData = (data) => {
	return data.map(({ nameRu, nameKz, ...props }) => ({ rus: nameRu, kz: nameKz, ...props }))
}
